import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BlockUser from '@fiverr-private/block_user';
import Reviews from '@fiverr-private/reviews';
import InfoPanel from './InfoPanel';
import StickyProfile from './StickyProfile';
import Gigs from './Gigs';
import {
    buildSellerCardData,
    buildPortfolioData,
    buildFiverrLearnData,
    buildProSubCategories,
    buildWideGigData
} from './dataBuilder';
import translations from '../translations/en.json';
import reportEvent from './lib/reportEvent';
import { triggerMixPanelEvent, Events } from './lib/mixpanelEvents';
import './index.scss';
import '@fiverr-private/block_user/dist/index.css';
import '@fiverr-private/reviews/dist/index.css';

const { VIEWED_PAGE, INTERACTED, VIEWED_SELLER_PORTFOLIO, CLICKED_CONTACT_ME } = Events.GeneralEvents;
const showReviews = (reviewsObject) => (!!(reviewsObject && reviewsObject.reviews && reviewsObject.reviews.length));

export default class Index extends Component {
    static get boundFunctions() {
        return [
            'handleFilterChange',
            'handlePortfolioClick',
            'handleContactClick',
            'scroll'

        ];
    }

    constructor(props) {
        super(props);
        i18n.add(translations);

        this.constructor.boundFunctions.forEach((fn) => this[fn] = this[fn].bind(this));
    }

    componentDidMount() {
        const { requestContext, seller_card, viewObject, courses } = this.props;
        const {
            id,
            country,
            member_since,
            response_time,
            recent_delivery
        } = seller_card.user;

        window.userId = requestContext.current_user && requestContext.current_user.id;
        window.sellerId = id;
        window.activeGigsCount = viewObject.gig_ids;

        reportEvent('seller_page.show');

        const avarage_response_time = response_time > 0 ? { 'Avarage response time': response_time } : {};

        triggerMixPanelEvent(VIEWED_PAGE, this.props, {
            'Seller Country': country,
            'Member since': new Date(member_since * 1000).getFullYear(),
            'Learn courses': courses.filter((course) => course.progression_status === 3).length,
            'Recent delivery': recent_delivery,
            ...avarage_response_time
        });
    }

    handleFilterChange(filterType) {
        const mixPanelAction = ({
            'all': 'Filter most recent',
            'positive': 'Filter positive reviews',
            'negative': 'Filter negative reviews'
        })[filterType];

        triggerMixPanelEvent(INTERACTED, this.props, { Action: mixPanelAction });
    }

    handlePortfolioClick() {
        triggerMixPanelEvent(VIEWED_SELLER_PORTFOLIO, this.props, {});
    }

    handleContactClick() {
        reportEvent('seller_page.contact_me');
        triggerMixPanelEvent(CLICKED_CONTACT_ME, this.props, {});
    }

    scroll(comp) {
        this[comp].scrollIntoView({ block: 'start', behavior: 'smooth'});
    }

    render() {
        const {
            user,
            seller_card,
            pro_badge: { pro_sub_categories },
            user_analytics,
            portfolio_projects,
            courses,
            seller_profile,
            buying_reviews,
            selling_reviews,
            funnelGigData,
            gigs,
            interaction_block,
            requestContext: {
                csrf_token: csrfToken,
                page_ctx_id: pageCtxId,
                current_user: currentUser,
                params: {
                    user_id: userId
                }
            },
            viewObject: {
                gig_ids: gigIds,
                currency,
                rollouts
            }
        } = this.props;

        const sellerCardData = buildSellerCardData(seller_card, user_analytics, user, currentUser, gigIds, pageCtxId, rollouts),
            portfolioProjects = buildPortfolioData(portfolio_projects, user),
            fiverrLearnCourses = buildFiverrLearnData(courses),
            proSubCategories = buildProSubCategories(pro_sub_categories),
            wideGigData = buildWideGigData(funnelGigData, gigs, currency, csrfToken),
            skillTests = seller_profile.passed_seller_tests;

        const _gigs = wideGigData.gig ? gigs.filter((gig) => gig.gig_id !== wideGigData.gig.gig_id) : gigs;

        const gigProps = {
                gigs: _gigs,
                wideGigData,
                user,
                context: {
                    pageCtxId,
                    abTests: {
                        PRO_EXPERIENCE: 2
                    }
                },
                shouldEnrichData: true
            },
            showBuyingReviews = showReviews(buying_reviews),
            showSellingReviews = showReviews(selling_reviews),
            isBlocked = interaction_block && interaction_block.current_user_blocking,
            { is_seller, has_live_gigs } = sellerCardData.user;

        const buyingReviews = {...buying_reviews, biEventGroup: 'seller_page'},
            sellingReviews = {...selling_reviews, biEventGroup: 'seller_page'};

        const scrollToData = [
            { ref: 'gigRef', title: i18n.t('seller_profile.nav.gigs'), scrollFunc: this.scroll },
            { ref: 'reviewsRef', title: i18n.t('seller_profile.nav.reviews'), scrollFunc: this.scroll }
        ];

        return (
            <div className="user-page-perseus">
                <StickyProfile contactClick={this.handleContactClick} sellerCard={sellerCardData}/>
                <BlockUser isBlocked={isBlocked} userId={sellerCardData.user.id} username={userId}/>
                <div className="content">
                    <InfoPanel proSubCategories={proSubCategories}
                        pageCtxId={pageCtxId}
                        sellerCard={sellerCardData}
                        scrollComponents={scrollToData}
                        portfolioProjects={portfolioProjects}
                        fiverrLearnCourses={fiverrLearnCourses}
                        sellerProfile={seller_profile}
                        skillTests={skillTests}
                        onPortfolioClick={(location) => this.handlePortfolioClick(location)}/>

                    <div className="gigs-panel" ref={(ref) => this.gigRef = ref}>
                        {(is_seller || has_live_gigs) &&
                            <Gigs {...gigProps}/>}
                        <div ref={(ref) => this.reviewsRef = ref}/>
                        {showBuyingReviews && <Reviews initialState={buyingReviews}
                            onFilterChange={(type) => this.handleFilterChange(type)}
                            onLoadMoreClick={() => triggerMixPanelEvent(INTERACTED, this.props, { Action: 'Load more' })}/>}
                        {showSellingReviews && <Reviews initialState={sellingReviews}
                            onFilterChange={(type) => this.handleFilterChange(type)}
                            onLoadMoreClick={() => triggerMixPanelEvent(INTERACTED, this.props, { Action: 'Load more' })}/>}
                    </div>
                </div>
            </div>
        );
    }
}

Index.propTypes = {
    seller_card: PropTypes.object,
    portfolio_projects: PropTypes.array,
    courses: PropTypes.array,
    seller_profile: PropTypes.object,
    gigs: PropTypes.array,
    interaction_block: PropTypes.object,
    viewObject: PropTypes.shape({
        page_ctx_id: PropTypes.string,
        gig_ids: PropTypes.array,
        currency: PropTypes.object,
        rollouts: PropTypes.object
    }),
    requestContext: PropTypes.shape({
        current_user: PropTypes.object,
        is_mobile: PropTypes.bool,
        page_ctx_id: PropTypes.string,
        params: PropTypes.object
    })
};

Index.defaultProps = {
    seller_card: {},
    portfolio_projects: [],
    courses: [],
    seller_profile: {},
    gigs: [],
    interaction_block: {},
    viewObject: {
        page_ctx_id: '',
        gig_ids: [],
        currency: {
            name: 'USD',
            rate: '1',
            symbol: '$'
        },
        rollouts: {}
    },
    requestContext: {
        current_user: {},
        page_ctx_id: '',
        params: {
            user_id: 0
        }
    }
};



// WEBPACK FOOTER //
// ./src/common/index.js